import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b1fb80fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "storage-container" }
const _hoisted_2 = { class: "progress-text" }

import { useUserStore } from "@/store/user-store";
import { MathUtils } from "three";
import { onMounted, computed, ref } from "vue";
import StorageRequestDialog from "@/components/Modals/StorageRequestDialog.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'StorageBar',
  setup(__props) {

let userStore = useUserStore();
const storageRequestDialog = ref(null);

const progressValue = computed(() => {
  if (!userStore.state.user) {
    return 0;
  }

  return MathUtils.clamp(
    Math.round(
      (userStore.state.user.usedStorage /
        userStore.state.user.availableStorage) * 100
    ),
    0,
    100
  );
});

const progressColorClass = computed(() => {
  if (progressValue.value >= 90) {
    return "danger";
  }
  if (progressValue.value >= 80) {
    return "warning";
  }
  return "";
});

const formatStorageGb = (value?: number) => {
  const gb = (value ?? 0) / (1000 * 1000 * 1000);
  return `${Number.isInteger(gb) ? gb : Number(gb.toFixed(2))} GB`;
};

const storageUsageText = computed(() => {
  return `${formatStorageGb(userStore.state.user?.usedStorage)} / ${formatStorageGb(userStore.state.user?.availableStorage)}`;
});

const requestMoreStorage = () => {
  storageRequestDialog.value?.show();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["storage-bar", [_unref(progressColorClass)]])
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(["progress-bar", [_unref(progressColorClass)]]),
        style: _normalizeStyle({ width: _unref(progressValue) + '%' })
      }, null, 6),
      _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(storageUsageText)), 1)
    ], 2),
    _createElementVNode("button", {
      class: "request-storage-btn",
      onClick: requestMoreStorage
    }, " + Request Extra Storage "),
    _createVNode(StorageRequestDialog, {
      class: "storage-request-dialog",
      ref_key: "storageRequestDialog",
      ref: storageRequestDialog
    }, null, 512)
  ]))
}
}

})